import { AES, enc } from "crypto-js";

const CRYPTOJS_SALTED_PREFIX = "U2FsdGVkX1";

// Encrypt a message using the secret key
export const encryptMessage = (message, secretKey) => {
  return secretKey && AES.encrypt(message, secretKey).toString();
};
// Decrypt a message using the secret key
export const decryptMessage = (ciphertext, secretKey) => {
  try {
    if (ciphertext == null || ciphertext === "" || !secretKey) return "";
    if (typeof ciphertext !== "string") return "";
    // Optimistic image captions are stored as plaintext (encrypt("") would
    // look like a caption and split galleries). AES.decrypt of plaintext
    // yields an empty Utf8 string, so pass non-ciphertext through.
    if (!ciphertext.startsWith(CRYPTOJS_SALTED_PREFIX)) {
      return ciphertext;
    }
    const decrypted = AES.decrypt(ciphertext, secretKey);
    return decrypted ? decrypted.toString(enc.Utf8) : "";
  } catch (error) {
    console.log("Decryption error:", error.message);
    return "";
  }
};


export const emojiUnicode=(emoji)=> {
  let hex = emoji.codePointAt(0).toString(16)
  return "0x" + hex
};

export const emojiDecode=(emoji)=> {
  let emj = String.fromCodePoint(emoji)
  return emj
};
